module.exports = __webpack_public_path__ + "img/android_download_btn_en.f369eabd.svg";